import React from 'react';
export const DEFAULT_RESET_TIMEOUT = 2000;
const useCopyToClipboard = function (url) {
  let resetTimeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_RESET_TIMEOUT;
  const [copied, setCopied] = React.useState(false);
  React.useEffect(() => {
    function reset() {
      setCopied(false);
    }
    if (copied) {
      setTimeout(reset, resetTimeout);
    }
  }, [copied]);
  function copyToClipboard() {
    window.navigator.clipboard.writeText(url);
    setCopied(true);
  }
  return {
    url,
    copied,
    copyToClipboard
  };
};
export default useCopyToClipboard;